import React, { useState, useEffect } from 'react';
import { Column } from '@ant-design/plots';
import NoData from '../../custom-components/NoData';

export const GrtHistogram = (props) => {
  const {
    data,
    padding,
    setColor,
    setLabelContent,
    isShowTooltip,
    labelPosition,
    labelColor,
    labelOpacity,
    tooltipTypeLabel,
    tooltipValueLabel,
    columnWidthRatio,
    isShowSlider,
    isShowScrollbar,
    isMultiColumn,
    spaceNum,
    rotateNum,
    isMedian,
    yAxisText,
    yAxisFontSize,
    yAxisColor,
    yAxisTitleOffset,
    yPosition,
    yTitlePosition,
    xAxisText,
    xAxisFontSize,
    xAxisColor,
    xAxisTitleOffset,
    xPosition,
    xTitlePosition,

    setXAxisLabel,
    setYAxisLabel,
    xLabelRotateNum,
    xLabelColor,
    xLabelOpacity,
    yLabelRotateNum,
    yLabelColor,
    yLabelOpacity,
    isShowNav,
    xField,
    yField,
    category,
    xLabelOffsetY,
    yLabelOffsetX,
    legendOffsetX,
    legendOffsetY,
    yAxisType,
    yAxisLabelMin,
    yAxisLabelMax,
    yAxisLabelTickCount,
    isShowTooltipTitle,
    tooltipTitle,
  } = props;



  let defalutConfig = {
    data,
    isGroup: isMultiColumn,
    xField,
    yField,

    seriesField: isMultiColumn ? category : null,
    autoFit: true,
    legend: isShowNav && {
      offsetX: legendOffsetX,
      offsetY: legendOffsetY,
    },
    padding,

    // dodgePadding: (isMultiColumn && data && date.length > 1) ? spaceNum : null,

    color: setColor ? setColor : ['#5B8FF9', '#61DDAA', '#65789B', '#F6BD16', '#7262FD', '#78D3F8', '#9661BC', '#F6903D', '#008685', '#F08BB4'],
    columnWidthRatio: columnWidthRatio ? columnWidthRatio / 1 : 0.8,
    label: {

      position: labelPosition,
      content: setLabelContent,
      style: {
        fill: labelColor,
        opacity: labelOpacity ? labelOpacity / 1 : 1
      }
    },
    tooltip: isShowTooltip ? {
      showTitle: isShowTooltipTitle,
      title: tooltipTitle
      // fields: [xField, yField],
    } : isShowTooltip,
    yAxis: {
      type: yAxisType ? 'log' : 'linear',
      position: yPosition,
      label: {
        formatter: setYAxisLabel,
        rotate: yLabelRotateNum,
        autoHide: true,
        autoRotate: false,
        offsetX: yLabelOffsetX,
        style: {
          fill: yLabelColor,
          opacity: yLabelOpacity ? yLabelOpacity / 1 : 1
        }
      },
      title: {
        text: yAxisText,
        autoRotate: true,
        offset: yAxisTitleOffset,
        position: yTitlePosition,
        style: {
          fontSize: yAxisFontSize,
          fill: yAxisColor
        }
      },
      min: yAxisLabelMin,
      max: yAxisLabelMax,
      tickCount: yAxisLabelTickCount,
      tickMethod: 'd3-linear'
    },
    xAxis: {
      // name: 'sss',
      label: {
        offsetY: xLabelOffsetY,
        rotate: xLabelRotateNum,
        autoHide: true,
        autoRotate: false,
        formatter: setXAxisLabel,
        style: {
          fill: xLabelColor,
          opacity: xLabelOpacity ? xLabelOpacity / 1 : 1
        }
      },

      position: xPosition,
      title: {
        text: xAxisText,
        autoRotate: false,
        offset: xAxisTitleOffset,
        position: xTitlePosition,
        style: {
          fontSize: xAxisFontSize,
          fill: xAxisColor
        }
      }

    },
    slider: isShowSlider ? {
      start: 0,
      end: 0.2,
    } : null,
    scrollbar: isShowScrollbar ? {
      type: 'horizontal',
    } : null,
    meta: {
      [xField]: {
        alias: tooltipTypeLabel
      },
      [yField]: {
        alias: tooltipValueLabel
      }
    },
    annotations: isMedian ? [
      // 低于中位数颜色变化
      {
        type: 'regionFilter',
        start: ['min', 'median'],
        end: ['max', '0'],
        // color: '#ccc',
        style: {
          stroke: '#F4664A',
          lineDash: [2, 2],
        },
      },
      {
        type: 'text',
        position: ['min', 'median'],
        content: '中位数',
        offsetY: -4,
        style: {
          textBaseline: 'bottom',
        },
      },
      {
        type: 'line',
        start: ['min', 'median'],
        end: ['max', 'median'],
        style: {
          stroke: '#F4664A',
          lineDash: [2, 2],
        },
      },
    ] : null,
  };


  // const [config, setConfig] = useState(defalutConfig);
  // // 整数（由于antv没提供整数功能是，如果y轴有大于3的会默认整数，如果是一或者二即使设置了minTickInterval也不生效，所以判断要显示几个横轴）
  // const setConfigYAxis = () => {
  //   if (data && data.length > 0) {
  //     let countFlag = 0;
  //     data.forEach(v => {
  //       if (v[yField] >= 3) {
  //         countFlag = 3
  //       } else if (v[yField] === 2) {
  //         countFlag = 2
  //       } else {
  //         countFlag = 1
  //       }
  //     })
  //     if (countFlag === 3) {
  //       defalutConfig.yAxis.minTickInterval = 1
  //     } else if (countFlag === 2) {
  //       defalutConfig.yAxis.tickCount = 2;
  //       defalutConfig.yAxis.tickMethod = 'd3-linear'
  //     } else {
  //       defalutConfig.yAxis.tickCount = 1;
  //       defalutConfig.yAxis.tickMethod = 'd3-linear'
  //     }
  //     setConfig(defalutConfig)
  //   }
  // }

  // useEffect(() => {
  //   if (yAxisInteger) {
  //     setConfigYAxis()
  //   }
  // }, [data])










  return <>
    <Column style={{ display: data && data.length > 0 ? 'block' : 'none' }}  {...defalutConfig} />
    {
      !data || data.length < 1 ? <NoData /> : null
    }
  </>

};

